import type { SYSActions, SYSState } from ".."
import { ovl } from ".."

type ReactorsValueType = {
  fn: (context: ReactorFnState) => ReactorReturnType
  debounce: {
    debounceMS?: number
    timeoutHandle?: any
  }
}
export let reactors = new Map<string, ReactorsValueType[]>()
export type ReactorFnState = {
  state: SYSState
  actions: SYSActions
  hitPath: string
  value: any
}

export const RemoveGlobalReactor = (paths: string[]) => {
  paths.map((m) => reactors.delete(m))
}

export const AddGlobalReactor = (
  paths: string[],
  cb: (context: ReactorFnState) => any,
  debounceMS: number = 0
) => {
  let debounce = { debounceMS }
  paths.forEach((p) => {
    let exist: ReactorsValueType[] = reactors.get(p)
    if (exist) {
      exist.push({ fn: cb, debounce })
    } else {
      exist = [{ fn: cb, debounce }]
    }
    // make sure debounced onces gets called last
    exist.sort((a, b) => a.debounce.debounceMS - b.debounce.debounceMS)
    reactors.set(p, exist)
  })
}

export type ReactorReturnType = { cancel?: boolean; newValue?: any }

export const handleReactor = (path: string, value): ReactorReturnType => {
  let reactorvalues = reactors.get(path)
  if (reactorvalues) {
    let retValue: ReactorReturnType = { cancel: undefined, newValue: undefined }
    reactorvalues.forEach((reactor) => {
      if (reactor.debounce.debounceMS !== 0) {
        clearTimeout(reactor.debounce.timeoutHandle)
        reactor.debounce.timeoutHandle = setTimeout(async () => {
          if (retValue.cancel) {
            return
          }
          await reactor.fn({
            actions: ovl.getActions(),

            state: ovl.getState(),
            hitPath: path,
            value: retValue.newValue ? retValue.newValue : value,
          })
        }, reactor.debounce.debounceMS)
      } else {
        let res = reactor.fn({
          actions: ovl.getActions(),

          state: ovl.getState(),
          hitPath: path,
          value,
        })
        if (res?.cancel) {
          retValue.cancel = true
        }
        if (res?.newValue !== undefined) {
          retValue.newValue = res.newValue
        }
      }
    })
    return retValue
  }
}
